// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_box {
  display: flex;
  flex-direction: row;
  gap: 20px;
  width: 100%;
}

.container_deliveryman {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  overflow: scroll;
  border: 2px solid var(--ColorSecondaryDark);
  border-radius: 20px;
  margin: 5px;
}

.container_deliveryman a {
  text-decoration: none;
  color: black;
}

.card_box {
  border: 2px solid var(--ColorSecondaryDark);
  border-radius: 20px;
  flex: .7 1;
  margin: 5px;
}

.card_info {
  margin: 4rem;
  display: flex;
  gap: 20px;
}

.box_deliveryman {
  background-color: var(--ColorPrimary);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: auto;
  height: 10vh;
  margin: 2rem;
  border-radius: 20px;
  padding: 1.5rem;
  overflow: auto;
  transition: all 0.6s ease-in-out;
}

.info_box {
  margin: 10px;
}

.box_deliveryman:hover {
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

.image_box img {
  border-radius: 100%;
  height: 7rem;
  width: 7rem;
  object-fit: contain;
}

.button_box_deliveryman {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 0px;
  grid-row-gap: 0px;
}

.button_map button {
  border: 2px solid var(--ColorSecondaryDark);
  background-color: var(--ColorSecondaryDark);
  height: 100%;
  padding: 0.4rem;
  width: 50%;
  border-radius: 100%;
  transition: all 0.6s ease-in-out;
}

.button_details {
  border: 2px solid var(--ColorSecondaryDark);
  background-color: var(--ColorSecondaryDark);
  border-radius: 5px;
  height: 40px;
  align-self: center;
}

.button_map button:hover {
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

.button_details button {
  border: 2px solid var(--ColorSecondaryDark);
  background-color: var(--ColorSecondaryDark);
  color: white;
  font-weight: bold;
  padding: 0.4rem;
  height: 100%;
  border-radius: 20px;
  transition: all 0.6s ease-in-out;
}

.button_details button:hover {
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

.root-delivery {
  display: grid;
  grid-gap: 20px;
  grid-template-columns: 1fr;
  grid-template-rows: 3fr 1fr;
  height: 98vh;
}

.children-root--delivery-one {
  grid-column-start: 0;
  grid-row-start: 0;
}

.children-root--delivery-two {
  grid-column-start: 0;
  grid-row-start: 0;
  flex-direction: row;
  display: flex;
  justify-content: space-evenly;
  max-height: 300px;
}

.children-root--delivery-three {
  grid-column-start: 0;
  grid-row-start: 0;
  flex-direction: row;
  display: flex;
  justify-content: space-evenly;
  max-height: 300px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Delivery/delivery.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,gBAAgB;EAChB,2CAA2C;EAC3C,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,UAAQ;EACR,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,uBAAuB;EACvB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,2CAA2C;EAC3C,2CAA2C;EAC3C,YAAY;EACZ,eAAe;EACf,UAAU;EACV,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,2CAA2C;EAC3C,2CAA2C;EAC3C,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,2CAA2C;EAC3C,2CAA2C;EAC3C,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,cAAc;EACd,0BAA0B;EAC1B,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,6BAA6B;EAC7B,iBAAiB;AACnB","sourcesContent":[".container_box {\n  display: flex;\n  flex-direction: row;\n  gap: 20px;\n  width: 100%;\n}\n\n.container_deliveryman {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  overflow: scroll;\n  border: 2px solid var(--ColorSecondaryDark);\n  border-radius: 20px;\n  margin: 5px;\n}\n\n.container_deliveryman a {\n  text-decoration: none;\n  color: black;\n}\n\n.card_box {\n  border: 2px solid var(--ColorSecondaryDark);\n  border-radius: 20px;\n  flex: .7;\n  margin: 5px;\n}\n\n.card_info {\n  margin: 4rem;\n  display: flex;\n  gap: 20px;\n}\n\n.box_deliveryman {\n  background-color: var(--ColorPrimary);\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  width: auto;\n  height: 10vh;\n  margin: 2rem;\n  border-radius: 20px;\n  padding: 1.5rem;\n  overflow: auto;\n  transition: all 0.6s ease-in-out;\n}\n\n.info_box {\n  margin: 10px;\n}\n\n.box_deliveryman:hover {\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);\n}\n\n.image_box img {\n  border-radius: 100%;\n  height: 7rem;\n  width: 7rem;\n  object-fit: contain;\n}\n\n.button_box_deliveryman {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-template-rows: 1fr;\n  grid-column-gap: 0px;\n  grid-row-gap: 0px;\n}\n\n.button_map button {\n  border: 2px solid var(--ColorSecondaryDark);\n  background-color: var(--ColorSecondaryDark);\n  height: 100%;\n  padding: 0.4rem;\n  width: 50%;\n  border-radius: 100%;\n  transition: all 0.6s ease-in-out;\n}\n\n.button_details {\n  border: 2px solid var(--ColorSecondaryDark);\n  background-color: var(--ColorSecondaryDark);\n  border-radius: 5px;\n  height: 40px;\n  align-self: center;\n}\n\n.button_map button:hover {\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);\n}\n\n.button_details button {\n  border: 2px solid var(--ColorSecondaryDark);\n  background-color: var(--ColorSecondaryDark);\n  color: white;\n  font-weight: bold;\n  padding: 0.4rem;\n  height: 100%;\n  border-radius: 20px;\n  transition: all 0.6s ease-in-out;\n}\n\n.button_details button:hover {\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);\n}\n\n.root-delivery {\n  display: grid;\n  grid-gap: 20px;\n  grid-template-columns: 1fr;\n  grid-template-rows: 3fr 1fr;\n  height: 98vh;\n}\n\n.children-root--delivery-one {\n  grid-column-start: 0;\n  grid-row-start: 0;\n}\n\n.children-root--delivery-two {\n  grid-column-start: 0;\n  grid-row-start: 0;\n  flex-direction: row;\n  display: flex;\n  justify-content: space-evenly;\n  max-height: 300px;\n}\n\n.children-root--delivery-three {\n  grid-column-start: 0;\n  grid-row-start: 0;\n  flex-direction: row;\n  display: flex;\n  justify-content: space-evenly;\n  max-height: 300px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
